import WindowViewModel from '@/ViewModels/Controls/WindowViewModel';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import TwoFactorAuthViewModel from '@/Components/TwoFaktorAuth/TwoFactorAuthViewModel';
import ButtonViewModel from '@/ViewModels/Controls/ButtonViewModel';
import LabelViewModelBuilder from '@/Builder/LabelViewModelBuilder';
import ButtonViewModelBuilder from '@/Builder/ButtonViewModelBuilder';
import ComponentManager from '@/Management/ComponentManager';
import * as DateHelper from '@/Utility/DateHelper';
import {ITwoFactorPopupViewModelConstructorParameter} from '#/DefaultViewExtensionInterfaces';
import QRCodeHelper from "@/Components/TwoFaktorAuth/QRCodeHelper";

/**
 * Window-Komponente, welche den 2FA in einem Fenster anzeigt
 */
export default class TwoFactorPopupViewModel extends WindowViewModel {
    private context: DetailViewContext;
    public twoFactorViewModel: TwoFactorAuthViewModel;
    public exportPDFButton: ButtonViewModel;

    public constructor(protected params: ITwoFactorPopupViewModelConstructorParameter) {
        super($.extend(params, {
            width: 600,
            height: 380,
            isModal: true,
            isOpen: false,
            isVisible: true,
            allowClose: true,
            isDraggable: false,
            isResizable: false,
            headline: new LabelViewModelBuilder()
                .withErgName('RAD.RADFOUNDATION.PROBLEMDOMAIN.USER_QR_CODE_WINDOW_TITLE')
                .build()
            ,
            onOpen: () => {
                this.twoFactorViewModel.generateToken(false);
            },
            onClose: params.onClose ?? (() => {
                this.twoFactorViewModel.token(null);
            }),
            centerOnWindowResize: true,
            locator: '2fa.window'
        }));

        this.twoFactorViewModel = new TwoFactorAuthViewModel(this.params);
        this.context = this.paramOrDefault(params.context, null);

        this.exportPDFButton = this.createExportPDFButton();
    }

    private createExportPDFButton(): ButtonViewModel {
        return new ButtonViewModelBuilder()
            .withOnClick(() => {
                QRCodeHelper.downloadQRCode(this.twoFactorViewModel.userName);
            })
            .withLabel().withErgName('RAD.RADFOUNDATION.PROBLEMDOMAIN.USER_QR_EXPORT_FILE').done()
            .withLocator('export-file')
            .withParentLocator(this.locator)
            .build()
    }

    

    protected getUsername(): string {
        return this.twoFactorViewModel.userName;
    }
}

ComponentManager.setViewModel('TwoFactorPopupViewModel', TwoFactorPopupViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');